/**
 * Point d'entrée principal de l'application QCM
 * Ce fichier initialise les styles et la configuration UI
 *
 * Note: Le moteur QCM est chargé dynamiquement comme script classique
 * car il n'est pas compatible avec les imports ES6
 */

// Chargement dynamique du moteur QCM (avec attente du chargement)
const loadQcmEngine = new Promise((resolve, reject) => {
  const qcmScript = document.createElement('script');
  qcmScript.src = import.meta.env.DEV
    ? '/node_modules/@mx-packages/qcm-engine/dist/qcm2.min.js'  // Dev: pointe vers node_modules
    : '/js/libs/qcm2.min.js';   // Prod: utilise la copie dans public (note: la copie est automatisée lors du build.)
  qcmScript.onload = resolve;
  qcmScript.onerror = reject;
  document.head.appendChild(qcmScript);
});

// Attendre que le moteur QCM soit chargé avant de continuer
await loadQcmEngine;

// Import de la configuration de développement (uniquement en mode dev)
if (import.meta.env.DEV) {
  await import('./dev-config.js');
}

// Import des styles communs (inclut les variables CSS)
import '../scss/common.scss';

// Import de TOUS les thèmes (chargés une seule fois)
// Le switch se fait via l'attribut data-theme sur <html>
import '../scss/themes/pe-main.scss';
import '../scss/themes/pe-alt1.scss';
import '../scss/themes/pe-alt2.scss';

// Import de la configuration UI
import { constQcmUi, obQcmUI } from './config/ui-config.js';

// Import du système de thèmes
import { initTheme, setTheme, getCurrentTheme, listThemes } from './utils/theme-switcher.js';

// Import du dispatcher d'événements moteur
import { initDispatch } from './dispatch.js';

/**
 * Expose les configurations UI globalement
 * Le moteur QCM legacy a besoin de ces objets dans le scope global
 */
window.constQcmUi = constQcmUi;
window.obQcmUI = obQcmUI;

/**
 * Expose les fonctions de gestion de thèmes globalement
 * Pour permettre les tests depuis la console
 */
window.QCM = {
  theme: {
    set: setTheme,
    current: getCurrentTheme,
    list: listThemes
  }
};

/**
 * Démarrage de l'application au chargement du DOM
 */
$(document).ready(() => {
  console.log('DOM ready - Initialisation de l\'application QCM');

  // 1. Initialiser le moteur QCM IMMÉDIATEMENT (ne pas attendre)
  if (typeof window.init === 'function') {
    window.init();
    initDispatch();
    console.log('✅ Moteur QCM initialisé');
  } else {
    console.error('❌ La fonction window.init() n\'est pas disponible. Vérifiez que le moteur QCM est correctement chargé.');
  }

  // 2. Initialiser le système de thèmes en parallèle (sans bloquer)
  initTheme().then(() => {
    console.log('');
    console.log('📋 Commandes disponibles dans la console:');
    console.log('  QCM.theme.list()           - Liste tous les thèmes');
    console.log('  QCM.theme.current()        - Thème actuel');
    console.log('  QCM.theme.set("pe-main")   - Change de thème');
    console.log('');
  }).catch((error) => {
    console.error('❌ Erreur lors de l\'initialisation des thèmes:', error);
  });
});
